import React, {useEffect, useState} from "react";
import {convertTimestampToDateTime} from "../../../helper/helper";
import { UserModel } from "../../../interfaces/user.interface";
import TableHeader from "../../../components/Common/TableHeader";
import PaginationButtons from "../../../components/Common/Pagination";
import { getPaymentHistoryDetails } from "./services/UserPaymentDetails.service";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";


interface UserPaymentDetailsProps {
    user: UserModel;
    paymentDetailsModalOpen: boolean;
    onClose: (isOpen: boolean) => void;
  }

const UserPaymentDetails = ({user, paymentDetailsModalOpen, onClose}: UserPaymentDetailsProps) => {
    const [paymentHistory, setPaymentHistory] = useState<Array<any>>([]);
    const [loader, setLoader] = useState(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number | null>(null);

    const fetchPaymentHistory = async () => {
        setLoader(true);
        const { payments, totalPages } = await getPaymentHistoryDetails(user?.email!, currentPage);
    
        if (payments) {
          setPaymentHistory(payments);
          setTotalPages(totalPages);
        }
        setLoader(false);
      };
    
      useEffect(() => {
        if (user) {
          fetchPaymentHistory();
        }
      }, [user, currentPage]);

    const handlePageChange = (page: number | string) => {
        setCurrentPage(+page);
    };
    return (
        <div className="p-0 md:p-4">
            {loader ? (
                <LoadingSpinner/>
            ) : (
                <>
                    <div className="flex flex-col gap-4 mb-4">
                        <h1 className="text-storyblue text-xl font-bold text-start capitalize">
                            Payment history of {user?.firstName} {user?.lastName}
                        </h1>

                        <button
                            type="button"
                            className={`w-[5rem] flex justify-center bg-storyblueSecondLightText text-white hover:text-white font-bold rounded-2xl px-4 py-2 text-base mr-2`}
                            onClick={() => onClose(false)}
                        >
                            Back
                        </button>
                    </div>
                    <div className="w-full overflow-auto">
                        {paymentHistory?.length > 0 ? (
                            <table className="min-w-full border border-gray-300">
                                {TableHeader([
                                    "Amount Charged",
                                    "Coupon",
                                    "Discount Availed",
                                    "Payment Description",
                                    "Payment Time",
                                ])}

                                <tbody>
                                {paymentHistory &&
                                    paymentHistory?.map((payment, index) => (
                                        <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : ""}>
                                            <td
                                                className="py-2 text-left px-4 border-b"
                                            >
                                                ${" "}
                                                {payment?.couponDiscount
                                                    ? (payment?.amount - payment?.couponDiscount).toFixed(2)
                                                    : payment?.amount}
                                            </td>
                                            <td className="py-2 text-left px-4 border-b">{payment?.coupon || "-"}</td>
                                            <td className="py-2 text-left px-4 border-b">
                                                {payment?.couponDiscount ? `$ ${payment?.couponDiscount}` : "-"}
                                            </td>
                                            <td className="py-2 text-left px-4 border-b">{payment?.description}</td>

                                            <td className="py-2 text-left px-4 border-b">
                                                {convertTimestampToDateTime(payment?.timestamp)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <NoItemsFound message='No Payments Found' />
                        )}
                    </div>
                </>
            )}
            <div className="flex justify-end mt-4 gap-2">
                {(totalPages ?? 0) > 1 && (
                    <PaginationButtons
                        totalPages={totalPages!}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                )}
            </div>
        </div>
    );
};

export default UserPaymentDetails;
